import Vue from 'vue';
export default Vue.extend({
    props: {
        size: {
            type: String,
            default: 'default'
        }
    }
});
